export default __webpack_public_path__ + "static/backgroundArchive--blurH-7fa90903f698afdc23596a80084d9575.jpg";